import Vue from 'vue';
import { GLOBAL_ERROR, USER_ERROR_TYPE } from '../../utils/constants';
import {
  resetPassword,
  sendResetPasswordEmail
} from '../../api/reset-password';
import {
  getUser as getUserApi,
  saveUserProfile as saveUserProfileApi,
  getUserOrganisations as getUserOrganisationsApi,
  updateUserOrganisation as updateUserOrganisationApi
} from '../../api/user';
import router from '../../router';
import routeNames from '../../router/route-names';

export function getUser({ commit }, isIgnoreCache) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['loadingUser', true]);
      const user = await getUserApi(isIgnoreCache);
      // Ensure the noCorporateEmail resolves to false instead of undefined
      if (user && user.profile && !user.profile.noCorporateEmail) {
        user.profile.noCorporateEmail = false;
      }
      commit('setUser', user);
      commit('setState', ['loadingUser', false]);
      return resolve(user);
    } catch (err) {
      commit('setState', ['loadingUser', false]);
      // eslint-disable-next-line
      console.error(err);
      
      if (err.message.includes(USER_ERROR_TYPE.notFound)) {
        router.push({ name: routeNames.logout });
        return;
      }
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR
      });
      return reject();
    }
  });
}

export function resetPasswordEmail({ commit }, email) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['sendingPasswordEmail', true]);
      await sendResetPasswordEmail(email);
      commit('setState', ['sendingPasswordEmail', false]);
      resolve();
    } catch (err) {
      commit('setResetPasswordEmailError', err.message);
      commit('setState', ['sendingPasswordEmail', false]);
      reject();
    }
  });
}

export function validateResetPassword({ commit }, { token, password }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['sendingResetPassword', true]);
      await resetPassword(token, password);
      commit('setState', ['sendingResetPassword', false]);
      resolve();
    } catch (err) {
      commit('setResetPasswordError', err.message);
      commit('setState', ['sendingResetPassword', false]);
      reject();
    }
  });
}

export function saveUserProfile({ commit, state }, profile) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['savingUser', true]);
      const {
        firstName,
        lastName,
        matchesOrganisations,
        corporateEmailVerified,
        ...profilePayload
      } = profile;
      const response = await saveUserProfileApi(profilePayload);
      // if company email requires verification, pop up notification for email sent
      if (response.validateEmailUrl) {
        const cloneValidateEmailUrl = response.validateEmailUrl;

        Vue.prototype.SAIDialog({
          body: `Your work email requires verification.
          An email has been sent to your company email, please verify your email to complete the profile.`,
          okText: 'Ok',
          displayHideAction: false,
          onOk: () => {
            return (window.location = cloneValidateEmailUrl);
          }
        });
      }
      delete response.validateEmailUrl;      
      commit('setUser', { 
        ...state.user, 
        profile: response, 
        contactDetails: {
          ...state.user.contactDetails,
          addressLineOne: response.addressLineOne,
          addressLineTwo: response.addressLineTwo,
          unitNumber: response.unitNumber,
          workPhone: response.workPhone
        }
      });
      commit('setState', ['savingUser', false]);
      return resolve(response);
    } catch (err) {
      commit('setState', ['savingUser', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR
      });
      return reject();
    }
  });
}

export function getUserOrganisations({ commit }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['loadingUserOrganisations', true]);
      const response = await getUserOrganisationsApi();
      commit('setUserOrganisations', response.organisations || []);
      commit('setState', ['loadingUserOrganisations', false]);
      return resolve();
    } catch (err) {
      commit('setState', ['loadingUserOrganisations', false]);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR
      });
      return reject();
    }
  });
}

export function updateUserOrganisation({ commit, state }, orgId) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['savingUserOrganisation', true]);
      await updateUserOrganisationApi(orgId);
      const updatedUser = {
        ...state.user,
        hasOrganisation: true
      };
      commit('setUser', updatedUser);
      commit('setState', ['savingUserOrganisation', false]);
      return resolve();
    } catch (err) {
      commit('setState', ['savingUserOrganisation', false]);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR
      });
      return reject();
    }
  });
}
